var map = {
	"./1.jpg": 182,
	"./audio.png": 7493,
	"./banner.png": 2962,
	"./bg1.png": 3824,
	"./bg2.png": 7913,
	"./bg3.png": 1425,
	"./bg4.png": 5303,
	"./bg5.png": 323,
	"./bg6.png": 6188,
	"./bg8.png": 5498,
	"./bg_kai.png": 817,
	"./bg_noData.png": 8198,
	"./big.png": 7933,
	"./cang.png": 3825,
	"./character.png": 4214,
	"./choose.png": 6394,
	"./classify.png": 2227,
	"./close.png": 1460,
	"./coProduct.png": 8908,
	"./coProduct1.png": 8756,
	"./collectionStory.png": 7701,
	"./datu.png": 464,
	"./datu1.png": 4146,
	"./down.png": 7953,
	"./fanhui.png": 4506,
	"./fanhui1.png": 2843,
	"./fengmian.jpg": 3211,
	"./index.mp4": 1263,
	"./introducte1.png": 1121,
	"./introducte2.png": 3285,
	"./introducte3.png": 8324,
	"./introducte4.png": 3575,
	"./jianjie1.png": 3606,
	"./jianjie2.png": 9865,
	"./jianjie3.png": 5614,
	"./left.png": 332,
	"./line.png": 5621,
	"./link.png": 6189,
	"./logo.png": 6949,
	"./logo1.png": 6458,
	"./logo2.png": 1637,
	"./lvshun.png": 7497,
	"./mulu.png": 6161,
	"./mulu1.png": 3371,
	"./noData.png": 3748,
	"./poetry.png": 5995,
	"./pyq.png": 3432,
	"./rotate.png": 8271,
	"./search.png": 2305,
	"./search1.png": 9447,
	"./shang.png": 1369,
	"./share.png": 9300,
	"./share1.jpg": 7295,
	"./share2.jpg": 3913,
	"./sort.png": 9579,
	"./sort1.png": 1356,
	"./sort2.png": 5916,
	"./start.png": 2333,
	"./stop.png": 8538,
	"./up.png": 5024,
	"./video.mp4": 567,
	"./video.png": 9235,
	"./video1.mp4": 3550,
	"./video1.png": 7858,
	"./wx.png": 4447,
	"./xia.png": 8308,
	"./yc-book.png": 1267,
	"./女生-晓秋.mp3": 8375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;